import * as actions from '~/src/entities/vases/store/actions';
import { EAction } from '~/src/entities/vases/store/constants/actions';
import { InferValueTypes } from '~/src/store';

import initialState, { TVasState } from './initialState';

export type TAction = ReturnType<InferValueTypes<typeof actions>>

const reducer = (state: TVasState = initialState, action: TAction) => {
    switch (action.type) {
        case EAction.Initialization: {
            return {
                ...state,
                ...action.payload,
            };
        }
        case EAction.SetLoading: {
            return {
                ...state,
                loading: action.payload.state,
            };
        }
        case EAction.SetLoaded: {
            return {
                ...state,
                loaded: action.payload.state,
            };
        }
        case EAction.SetCategory: {
            return {
                ...state,
                selectedCategory: action.payload.state,
            };
        }
        case EAction.ToggleShowAllCategoryItems: {
            return {
                ...state,
                available: {
                    ...state.available,
                    [action.payload.category]: {
                        ...state.available[action.payload.category],
                        showAll: action.payload.value,
                    },
                },
            };
        }
        case EAction.SetSpeedBonuses: {
            return {
                ...state,
                available: {
                    ...state.available,
                    speedBonuses: {
                        name: action.payload.available.name,
                        items: action.payload.available.items,
                    },
                },
                connected: {
                    ...state.connected,
                    speedBonuses: {
                        name: action.payload.connected.name,
                        items: action.payload.connected.items,
                    },
                },
            };
        }
        default:
            return { ...state };
    }
};

export default reducer;
